import { formatCurrency } from '@cast/utils';

export const formatCost = (value: number | undefined) =>
  value === undefined
    ? '--'
    : formatCurrency(value, { maximumFractionDigits: 2 });
